import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import UnitState from "@/modules/unit";
export const AssetListResolver = async function (to: Route, from: Route, next: Function) {
	const actions: Promise<any>[] = [];
	const titleListModule = getModule(TitleListState);
	const unitModule = getModule(UnitState);

	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!unitModule.units.length) {
		actions.push(unitModule.fetchUnits({ details: false }));
	}
	await Promise.all(actions);
	next();
};